import { Component, HostListener, OnInit, ResolvedReflectiveFactory, ViewChild, ElementRef  } from '@angular/core';
import { Location } from '@angular/common';
import { ActivatedRoute } from '@angular/router';

import notify from 'devextreme/ui/notify';
import DataSource from 'devextreme/data/data_source';
import { DxDataGridComponent, DxDropDownBoxComponent, DxFormComponent } from 'devextreme-angular';
import { encodeHtml } from 'devextreme/core/utils/string';
import { custom } from 'devextreme/ui/dialog';
import validationEngine from "devextreme/ui/validation_engine";

import moment from 'moment';

import { AuthService } from 'src/app/shared/services';
import { ufaService } from '../ufe.service';
import { PrintService } from 'src/app/pdf-ovi/pdfUFA.service';

@Component({
  selector: 'app-ufa',
  templateUrl: './ufa.component.html',
  styleUrls: ['./ufa.component.scss'],
  providers: [ufaService]
})
export class UfaComponent implements OnInit {

  @ViewChild("dropdown", { static: false }) dropdown!: DxDropDownBoxComponent;
  @ViewChild("listaTroskova", { static: false }) listaTroskova!: DxDropDownBoxComponent;
  @ViewChild("target", { static: false }) target!: DxDataGridComponent; 
  @ViewChild("primkeTablica", { static: false }) primkeTablica!: DxDataGridComponent;
  @ViewChild('formaGlavna', { static: false }) formaGlavna!: DxFormComponent;
  @ViewChild('myButton', { read: ElementRef }) buttonSpremi!: ElementRef;

  idkorisnik: any = localStorage.getItem('idsecuser');
  access_token: any = sessionStorage.getItem('token');
  idfirma: any = localStorage.getItem('firma');
  
  loadingVisible = false;
  naslovStranice: any;
  vrstaUFE: any;
  brojPrimke: any;
  godinaUFE: any;
  statusUFA: any;
  postojeStavke: boolean = false;
  samoPregled: boolean = false;
  ulaznafaktura = {};
  partner: any;
  partneri: any=[];
  datumRacuna = new Date();
  datumValute = new Date();
  poslovnicaPrijema: any;
  poslovnicePrijema: any;
  UFASpremljena: boolean = false;
  brojDanaZaIzracun: any;
  primke: any;
  displayPrimka: any;
  primkePartnera: any;
  primkeID: any;
  primkePrikaz: any;
  odabranePrimke: number[] = [];
  stavkePodtablica: any;
  brojUFE: any;
  today = new Date();
  brojdok: any;
  napomena: any;
  stavkeUFE: any = [];
  zaglavljeUFE: any = [];
  popisPrimki: any = [];
  ufaprimkeNapomena: any;
  primkeZaSlanje: any;
  otvaramEdit: boolean = false;
  dokument: any;
  tablica: any;
  tablicaPDV: any;
  stavkeISPIS: any;
  rekapitulacija: any;
  sifraPoslovnice: any;
  primkePrikazDropDown: any = [];
  iznosFooter: any;
  iznosFooterIzmjene: any = null;
  iznosedit: any;
  watermark: any;
  storniranBoolean: boolean = false;
  status: any;
  osnovica: any;
  porezUFA: any;
  eurikn: boolean=false;
  skladiste_primka: any[];
  noveCijene: any[] = [];
  uf_status: any;
  omoguciZavrseneIzmjene: boolean = false;
  saveButtonDisabled: boolean = false;

  constructor(
    private api: ufaService,
    private _location: Location,
    private _route: ActivatedRoute,
    private printService: PrintService,
    private authService: AuthService
  ) {
    this.vrstaUFE = +this._route.snapshot.params['vrsta'];
    this.statusUFA = this._route.snapshot.params['status'];
    this.dohvatiPoslovnicePrijema();
    this.dohvatiPartnere();

    if(this.vrstaUFE === 0){               // SAMO SE KREIRA NOVA UFA
      this.naslovStranice = 'Nova ulazna faktura';
      this.postojeStavke = false;
      this.dohvatibrojUFE();
      this.brojdok = null;
    } else if(this.statusUFA === 'z'){      // SAMO PREGLED ZAVRŠENE UFE
      this.naslovStranice = 'Prikaz ulazne fakture';
      this.dohvatiPodatkeUFEZ(this.vrstaUFE);
      this.brojdok = this.vrstaUFE;
      // this.dohvatiPrimkeUFEZ(this.vrstaUFE);
      this.samoPregled = true;
      this.UFASpremljena = true;
    } else {                                  // KADA SE UREĐUJE NEZAVRŠENA UFA
      this.naslovStranice = 'Uređivanje ulazne fakture';
      this.dohvatiPodatkeUFEN(this.vrstaUFE);
      this.dohvatiStavkeUFEN(this.vrstaUFE);
      this.dohvatiPrimkeUFEN(this.vrstaUFE);
      this.brojdok = this.vrstaUFE;
      this.UFASpremljena = true;
      this.postojeStavke = true;
    }
    this.partnerChange = this.partnerChange.bind(this);
    this.datumRacunaChange = this.datumRacunaChange.bind(this);
    this.datumValuteChange = this.datumValuteChange.bind(this);
    this.poslovnicaPrijemaChange = this.poslovnicaPrijemaChange.bind(this);
    this.closeDropDown = this.closeDropDown.bind(this);
    this.spremiDropdown = this.spremiDropdown.bind(this);
    this.calculateSummary = this.calculateSummary.bind(this);
  }

  ngOnInit(): void {  }

  onCellPrepared(e){
    if (e.rowType === "data"){
      if(e.data.do_status === 'S'){
        e.cellElement.style.color = 'red';
      }
    }
  }

  onContentReady(e){
    setTimeout(() => { 
      e.component.getEditor("partner_pa_id").focus();
    },
    200)  
  }

  onEditorEnterKey(e: any) {
    //console.log(e.dataField);
    switch(e.dataField) {
      case 'partner_pa_id':
        this.focusField('uf_brojracuna');
        break;
      case 'uf_brojracuna':
        this.focusField('uf_datum');
        break;
      case 'uf_datum':
        this.focusField('uf_valuta');
        break;
      case 'uf_valuta':
        this.focusField('uf_napomena');
        break;
      case 'uf_napomena':
        this.focusField('uf_brojnarudzbe');
        break;
      case 'uf_brojnarudzbe':
        this.focusField('poslovnica_po_id');
        break;
      case 'poslovnica_po_id':
        this.buttonSpremi.nativeElement.click();
        break;
    }
  }

  focusField(fieldName: string) {
    setTimeout(() => {
      const editor = this.formaGlavna.instance.getEditor(fieldName);
      if (editor) {
        editor.focus();
      }
    }, 50);
  }

  /// PRIKAZ U SELECT BOXU EDITOROPTIONSA
  displayPartner(e){
    if(e){
      return e.pa_sifra + ' - ' + e.pa_naziv;
    } else {      
      return '';
    }
  }

  partnerChange(e){
    if(e.value != undefined){
      this.partner = e.value;
      if(this.statusUFA !== 'z'){
        this.dohvatiZavrsenePrimkePartnera(this.partner);
      }
    } else {
      this.stavkePodtablica = [];
      this.primke = null;
      this.stavkeUFE = [];
    }
  }

  datumRacunaChange(e){
    let datumNove=new Date(2022, 0O13, 0O37); 
    this.datumRacuna = e.value;
    if(moment(this.datumRacuna).format("YYYY-MM-DD")<moment(datumNove).format("YYYY-MM-DD")){
      this.eurikn=false;
    }else{
      this.eurikn=true;
    }
  }

  datumValuteChange(e){
    this.datumValute = e.value;
  }

  poslovnicaPrijemaChange(e){
    this.poslovnicaPrijema = e.value;
  }

  displayPoslovnicaPrijema(e){
    if(e){
      return e.po_sifra + ' - ' + e.po_naziv;
    } else {
      return '';
    }
  }

  spremiUFA(e){
    this.saveButtonDisabled = true;
    let datumUFA;
    let datumValute;
    if(e.uf_datum != undefined || e.uf_datum != null){
      datumUFA = moment(e.uf_datum).format('YYYY-MM-DD')
    } else {
      datumUFA = null;
    }
    if(e.uf_valuta != undefined || e.uf_valuta != null){
      datumValute = moment(e.uf_valuta).format('YYYY-MM-DD')  
    } else {
      datumValute = null;
    }

    if(this.vrstaUFE === 0 && !this.UFASpremljena){
      this.loadingVisible = true;
      let podaciDodaj = {
        access_token: this.access_token,
        idfirma: this.idfirma,
        idkorisnik: this.idkorisnik,
        idposlovnica: this.poslovnicaPrijema,
        broj_ufe: this.brojUFE,
        idpartner: this.partner,
        datumracuna: datumUFA,
        brojracuna: e.uf_brojracuna,
        brojnarudzbe: e.uf_brojnarudzbe,
        datumvalute: datumValute,
        napomena: e.uf_napomena
      }
      var result = validationEngine.validateGroup("validacijaPrimka");
      if(result.isValid === true){
        this.ufaDodaj(podaciDodaj).then((res_add: any) =>{
          console.log(res_add);
          this.saveButtonDisabled = false;
          if (res_add == 1) {
            setTimeout(() => {
              this.dropdown.instance.open();
            }, 300);
          }
        });
      } else {
        notify('Potrebno je popuniti sva tražena polja!', 'error');
        this.loadingVisible = false;
        this.saveButtonDisabled = false;
      }
    } else {           ///// UREĐUJE SE POSTOJUĆA UFA    
      this.loadingVisible = true;
      this.saveButtonDisabled = false;
      let podaciUredi = {
        access_token: this.access_token,
        idfirma: this.idfirma,
        idkorisnik: this.idkorisnik,
        idposlovnica: this.poslovnicaPrijema,
        broj_ufe: this.brojUFE,
        idpartner: this.partner,
        datumracuna: datumUFA,
        brojracuna: e.uf_brojracuna,
        brojnarudzbe: e.uf_brojnarudzbe,
        datumvalute: datumValute,
        napomena: e.uf_napomena,
        idufa: this.brojdok
      }
      var result = validationEngine.validateGroup("validacijaPrimka");
      if(result.isValid === true){
        this.api.ufaUredi(podaciUredi).subscribe(res => {
          this.loadingVisible = false;
          this.dohvatiPodatkeUFEN(this.brojdok);
          if(res.success === true){
            // this.dodatnaPitanja = false;
            notify(res.message, 'success');
          } else {
            notify(res.message, 'error');
          }
        })  
      } else {
        notify('Potrebno je popuniti sva tražena polja!', 'error');
        this.loadingVisible = false;
      }    
    } 
  }

  ufaDodaj(podaciDodaj){
    return new Promise((resolve) => {
      this.api.ufaDodaj(podaciDodaj).subscribe(res => {
        this.loadingVisible = false;
        if(res.success === true){
          this.brojdok = res.data[0].rezultat;
          this.dohvatiPodatkeUFEN(this.brojdok);
          this.statusUFA = 'n';
          this.samoPregled = false;
          this.UFASpremljena = true;
          this.postojeStavke = true;
          notify(res.message, 'success');
          resolve(1);
        } else {
          notify(res.message, 'error');
          resolve(0);
        }
      });
    });
  }

  spremiUFAzavrsena(e){
    let datumUFA;
    let datumValute;
    if(e.uf_datum != undefined || e.uf_datum != null){
      datumUFA = moment(e.uf_datum).format('YYYY-MM-DD')
    } else {
      datumUFA = null;
    }
    if(e.uf_valuta != undefined || e.uf_valuta != null){
      datumValute = moment(e.uf_valuta).format('YYYY-MM-DD')  
    } else {
      datumValute = null;
    }
    this.loadingVisible = true;

      let podaciUredi = {
        access_token: this.access_token,
        idfirma: this.idfirma,
        idkorisnik: this.idkorisnik,
        datum: datumUFA,
        brojracuna: e.uf_brojracuna,
        datumvalute: datumValute,
        napomena: e.uf_napomena,
        idufa: e.UI_ID
      }
      var result = validationEngine.validateGroup("validacijaPrimka");
      if(result.isValid === true){
        this.api.zavrsenaufaUredi(podaciUredi).subscribe(res => {
          this.loadingVisible = false;
            this.dohvatiPodatkeUFEZ(e.UI_ID);
          if(res.success === true){
            // this.dodatnaPitanja = false;
            notify(res.message, 'success');
          } else {
            notify(res.message, 'error');
          }
        })
      } else {
        notify('Potrebno je popuniti sva tražena polja!', 'error');
        this.loadingVisible = false;
      }    
    }   
  
  odustaniUFA(){
    this._location.back();
    // this.primkeDropBox = null;
  }
  
  dohvatiPoslovnicePrijema(){
    let data = {
      access_token: this.access_token,
      idkorisnik: this.idkorisnik,
      idfirma: this.idfirma,
    }    
    this.api.poslovnicaPopis(data).subscribe(res => {
      if (res.success == true) {
        this.poslovnicePrijema = res.data;
      }
    });
  }

  dohvatiPartnere(){
    let podaci = {
      access_token: this.access_token,
      idkorisnik: this.idkorisnik,
      idfirma: this.idfirma,
    }
    this.api.dohvatiPartnere(podaci).subscribe(res => {
      if (res.success == true) {
        this.partneri = new DataSource({
          store: res.data
        });
      }
    })
  }
  /////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
  dohvatiZavrsenePrimkePartnera(idpartner){
   let podaci = {
      access_token: this.access_token,
      idkorisnik: this.idkorisnik,
      idfirma: this.idfirma,
      idpartner: idpartner,
      idufa: this.brojdok
    }
    this.primkeZaSlanje = [];
    this.api.otvorenaprimkaPopis(podaci).subscribe(res => {
      this.primke = res.data;
      this.primke.forEach(element => {
        this.primkeZaSlanje.push({pz_id: element.pz_id, oznaka: element.oznaka});
      });
      this.odabranePrimke = res.data.filter(x => x.oznaka === 1).map(x => x.pz_id);
      this.primkePrikazDropDown = res.data.filter(x => x.oznaka === 1).map(x => x.pz_id);
    })    
  }
  
  brojPrimkeDisplay(data){
    if(data){
      return data.do_broj + '/'+ data.pg_godina;
    } else {
      return false
    }
  }

  /***------------------------------------------------------------ */
  onExpanding(e){
    this.loadingVisible = true;
    this.stavkePodtablica = [];
    e.component.collapseAll(-1);
    this.api.primkastavkePopis({access_token: this.access_token, idkorisnik: this.idkorisnik, idfirma: this.idfirma, pz_id: e.key}).subscribe(res => {
      this.loadingVisible = false;
      if(res.success == true){
        this.stavkePodtablica = res.data;  
      } 
    })
  }

  dohvatibrojUFE(){
    let podaci = {
      access_token: this.access_token,
      idkorisnik: this.idkorisnik,
      idfirma: this.idfirma
    }
    this.api.dohvatibroj_ufe(podaci).subscribe(res => {
      if(res.success === true){
        this.brojUFE = res.data[0].broj_ufe;
        this.godinaUFE = this.today.getFullYear();
      } else {
        notify(res.message, 'error')
      }
    })
  }

  konvertiraj(a){
    return this.authService.konvertirajCijenu().konvertiraj(a);
  }
  konvertiraj2(a){
    var a = a;
    var predznak = '';
    if (typeof (a) == "number") {
      if (isNaN(a) || a === Infinity) {
        var str = '';
      } else {
        var str = String(a);
      }
    } else if (typeof (a) == "string") {
      var str = a;
    } else {
      var str = '';
    }

    if (str.indexOf("-") == 0) {
      str = str.substring(1, str.length);
      predznak = '-';
    }

    var duzina = str.length;
    var tocka = str.indexOf(".");
    var zarez = str.indexOf(",");
    if (tocka > 0) {
      var decimalnomjesto = tocka;
    } else if (zarez > 0) {
      var decimalnomjesto = zarez;
    } else {
      var decimalnomjesto = -1;
    }
    
    if (typeof (str) == "string") {
      if (decimalnomjesto > 0) {

        if (decimalnomjesto > 3) {
          var brojevi = '';
          var broj = 0;
          for (var i = 3; i < decimalnomjesto; i = i + 3) {
            brojevi = '.' + str.substring(decimalnomjesto - i, decimalnomjesto - (i - 3)) + brojevi;
            broj = i;
          }
          var prvi = str.substring(0, decimalnomjesto - broj) + brojevi;

        } else {
          var prvi = str.substring(0, decimalnomjesto);
        }
        if (decimalnomjesto == duzina - 3) {
          var decimal = str.substring(decimalnomjesto + 1, duzina) + '0';
        } else {
          //ako se zeli da pokazuje sve znamenke ili da zaokruzi na dvije
          //var decimal = str.substring(decimalnomjesto+1, duzina);
          var decimal = str.substring(decimalnomjesto + 1, duzina);
        }
        var ukupno = prvi + ',' + decimal;
        return predznak + ukupno;
      } else {
        if (duzina > 3) {
          var brojevi = '';
          var broj = 0;
          for (var i = 3; i < duzina; i = i + 3) {
            brojevi = '.' + str.substring(duzina - i, duzina - (i - 3)) + brojevi;
            broj = i;
          }
          var prvi = str.substring(0, duzina - broj) + brojevi;
          var decimal = '00';
          var ukupno = prvi + ',' + decimal;
          return predznak + ukupno;
        } else {
          var decimal = '00';
          if (str == '') {
            str = '0';
          }
          var ukupno = str + ',' + decimal;
          return predznak + ukupno;
        }
      }
    }
    return false;
  }
  /****--------------------------------- samo pregled završene ulazne fakture ----------------------------------------****/
  dohvatiPodatkeUFEZ(idufa){
    this.napomena = [];
    let data = {
      access_token: this.access_token,
      idkorisnik: this.idkorisnik,
      idfirma: this.idfirma,
      idufa: idufa
    }  
    this.api.ufa(data).subscribe(res => {
        this.ulaznafaktura = res.data[0];
        this.iznosedit = res.data[0].uf_iznos;
        this.poslovnicaPrijema = res.data[0].poslovnica_po_id;
        this.partner = res.data[0].partner_pa_id;
        this.brojUFE = res.data[0].uf_broj;
        this.godinaUFE = res.data[0].pg_godina;  
        this.iznosFooter = res.data[0].uf_iznos + res.data[0].uf_porez;
        this.sifraPoslovnice = res.data[0].po_sifra;
        this.osnovica = res.data[0].uf_iznos;
        this.porezUFA = res.data[0].uf_porez;
        this.uf_status = res.data[0].uf_status;
      
      // this.dohvatiZavrsenePrimkePartnera(res.data[0].partner_pa_id)
      if(res.data[0].uf_status === 'S'){
        console.log(res.data[0].uf_status);
        this.storniranBoolean = true;
        this.status = ' STORNO';
      } else {
        this.storniranBoolean = false;
      }   
      if(res.data[0].uf_napomena){
        this.napomena.push([     
          { text: 'Napomena: ' + res.data[0].uf_napomena, bold: false, alignment: 'left', fontSize: 10 }
        ])
      } else {
        this.napomena = [];
      }
      this.dohvatiStavkeUFEZ(this.vrstaUFE);
      this.dohvatiPrimkeUFEZ(idufa);
      // this.dohvatiZavrsenePrimkePartnera(res.data[0].partner_pa_id)
    })     
  }

  dohvatiStavkeUFEZ(id){
    console.log("UFSTATUS" + this.uf_status); 
    this.watermark = {};
    this.tablica = [];
    this.tablicaPDV = [];
    this.stavkeISPIS = [];
    this.stavkeUFE = [];
    this.stavkePodtablica = [];
    let podaci = {
      access_token: this.access_token,
      idkorisnik: this.idkorisnik,
      idfirma: this.idfirma,
      uf_status: this.uf_status,
      uf_broj: this.brojUFE,
      idufa: id
    }   
    this.api.ufastavkaPopis(podaci).subscribe(res => {
      if(res.success === true){
        // this.stavkeUFE = res.data;
        if(res.data.length > 0){
          this.postojeStavke = true;
        }
        let br1=0;
        for(let i=0; i<res.data.length; i++){
          br1++;
        }
        if(br1==1){
          res.data[0].pr_ulazvr = this.osnovica;
          res.data[0].porez_iznos = this.porezUFA;
        }

        let br = 0;
        for(let i = 0; i < res.data.length; i++){
          br++
          this.stavkeISPIS.push({
            rb: br + '.',
            ps_id: res.data[i].ps_id,
            barkod: res.data[i].barkod,
            ar_sifra: res.data[i].ar_sifra,
            artikl_ar_id: res.data[i].artikl_ar_id,
            ar_naziv: res.data[i].ar_naziv,
            jedinicamjere_JM_SIFRA: res.data[i].jedinicamjere_JM_SIFRA,
            ps_danisat: res.data[i].ps_danisat,
            ps_ulaz: res.data[i].ps_ulaz,
            ps_brutocij: res.data[i].ps_brutocij,
            ps_postorabata: res.data[i].ps_postorabata,
            ps_rabat: res.data[i].ps_rabat,
            ps_ulazc: res.data[i].ps_ulazc,
            ps_ulazvr: res.data[i].ps_ulazvr,
            ps_nabcij: res.data[i].ps_nabcij,
            ps_potnak: res.data[i].ps_potnak,
            ps_povnak: res.data[i].ps_povnak,
            pz_posto: res.data[i].pz_posto,
            ps_ruc: res.data[i].ps_ruc,
            ps_maloprodcijena: res.data[i].ps_maloprodcijena,
            prometzag_pz_id: res.data[i].prometzag_pz_id,
            ps_poreziznos: res.data[i].ps_poreziznos,
            ps_zavisni: res.data[i].ps_zavisni,
            porez_iznos: res.data[i].porez_iznos,
            neto_iznos: res.data[i].neto_iznos,
            bruto_iznos: res.data[i].bruto_iznos
          })
        }     
        this.stavkeISPIS.forEach(element => {
          this.stavkeUFE.unshift(element)
        });

        this.skladiste_primka = [...new Set(res.data.map(item => item.skladiste_primka))];
      }
    })       
  }


  /****--------------------------------- nedovršene ulazne fakture ----------------------------------------****/
  dohvatiPrimkeUFEN(idufa){
    let podaci = {
      idkorisnik: this.idkorisnik,
      idfirma: this.idfirma,
      access_token: this.access_token,
      idufa: idufa,
      idpartner: this.partner
    }
    this.api.otvorenaprimkaPopis(podaci).subscribe(res =>{
      if(res.success === true){
        this.odabranePrimke = res.data.filter(x => x.oznaka === 1).map(x => x.pz_id);
        this.primkePrikazDropDown = res.data.filter(x => x.oznaka === 1).map(x => x.pz_id);       
      }             
    })
  }

  dohvatiPodatkeUFEN(idufa){
    this.loadingVisible = true;
    this.napomena = [];
    let data = {
      access_token: this.access_token,
      idkorisnik: this.idkorisnik,
      idfirma: this.idfirma,
      idufa: idufa
    }
    this.api.ufa(data).subscribe(res => {
      if(res && res.data && res.data.length > 0){
        this.ulaznafaktura = res.data[0];
        this.iznosedit = res.data[0].uf_iznos;
        this.porezUFA = res.data[0].uf_porez; 
        this.osnovica = res.data[0].uf_iznos;
        this.poslovnicaPrijema = res.data[0].poslovnica_po_id;
        this.brojUFE = res.data[0].uf_broj;
        this.godinaUFE = res.data[0].pg_godina;
        this.sifraPoslovnice = res.data[0].po_sifra;
        this.iznosFooter = res.data[0].uf_iznos + res.data[0].uf_porez;
        if(res.data[0].uf_napomena){
          this.napomena.push([
            { text: 'Napomena: ' + res.data[0].uf_napomena, bold: false, alignment: 'left', fontSize: 10 }
          ])
        } else {
          this.napomena = [];
        }
        this.loadingVisible = false;
        this.calculateSummary = this.calculateSummary.bind(this);
      } else {
        this.loadingVisible = false;
      }
    })     
  }

  dohvatiStavkeUFEN(id){
    this.watermark = { text: 'Pretpregled', color: 'red', opacity: 0.3, bold: true, italics: false } 
    this.stavkeUFE = [];
    this.tablica = [];
    this.tablicaPDV = [];
    this.stavkeISPIS = [];
    this.stavkePodtablica = [];
    let podaci = {
      access_token: this.access_token,
      idkorisnik: this.idkorisnik,
      idfirma: this.idfirma,
      uf_status: this.uf_status,
      uf_broj: this.brojUFE,
      idufa: id
    }   
    this.api.ufastavkaPopis(podaci).subscribe(res => {
      if(res.success === true){
        let br = 0;
        for(let i = 0; i < res.data.length; i++){
          br++
          this.stavkeISPIS.push({
            rb: br + '.',
            ps_id: res.data[i].ps_id,
            barkod: res.data[i].barkod,
            ar_sifra: res.data[i].ar_sifra,
            artikl_ar_id: res.data[i].artikl_ar_id,
            ar_naziv: res.data[i].ar_naziv,
            jedinicamjere_JM_SIFRA: res.data[i].jedinicamjere_JM_SIFRA,
            ps_danisat: res.data[i].ps_danisat,
            ps_ulaz: res.data[i].ps_ulaz,
            ps_brutocij: res.data[i].ps_brutocij,
            ps_postorabata: res.data[i].ps_postorabata,
            ps_rabat: res.data[i].ps_rabat,
            ps_ulazc: res.data[i].ps_ulazc,
            ps_ulazvr: res.data[i].ps_ulazvr,
            ps_nabcij: res.data[i].ps_nabcij,
            ps_potnak: res.data[i].ps_potnak,
            ps_povnak: res.data[i].ps_povnak,
            pz_posto: res.data[i].pz_posto,
            ps_ruc: res.data[i].ps_ruc,
            ps_maloprodcijena: res.data[i].ps_maloprodcijena,
            prometzag_pz_id: res.data[i].prometzag_pz_id,
            ps_poreziznos: res.data[i].ps_poreziznos,
            ps_zavisni: res.data[i].ps_zavisni,
            porez_iznos: res.data[i].porez_iznos,
            neto_iznos: res.data[i].neto_iznos,
            bruto_iznos: res.data[i].bruto_iznos
            
  
          })
        }
        let br1=0;
        for(let i=0; i<res.data.length; i++){
          br1++;
        }
        if(br1==1){
          res.data[0].pr_ulazvr = this.osnovica;
          res.data[0].porez_iznos = this.porezUFA;
        }

        this.stavkeISPIS.forEach(element => {
          this.stavkeUFE.unshift(element)
        });
        let datumNoveGodine:Date = new Date(2022, 0O13, 0O37);  
        let poreziznos = 0;
        let osnovica = 0;
        res.data.forEach(element => {
          poreziznos += element.porez_iznos;
          osnovica += element.pr_ulazvr;
        }); 
      }
    })
  }

  calculateSummary(options) {
    //// UKUPNO
    if (options.name == "ukupno") {
      if (options.summaryProcess == 'start') {
          // Initializing "totalValue" here
          options.totalValue = 0;
      }
      if (options.summaryProcess == 'calculate') {
          // Modifying "totalValue" here
          //options.osnovica = options.value.bruto_iznos;
          //options.rabat = options.value.ps_rabat || 0;
          //options.totalValue += options.osnovica + options.rabat;
          options.totalValue += options.value.bruto_iznos;
      }
      if (options.summaryProcess == 'finalize') {
          // Assigning the final value to "totalValue" here
          return options.totalValue;
      }
    }
    //// RABAT
    if (options.name == "iznosPopusta") {
      if (options.summaryProcess == 'start') {
          // Initializing "totalValue" here
          options.totalValue = 0;
      }
      if (options.summaryProcess == 'calculate') {
          // Modifying "totalValue" here            
          //options.totalValue += options.value.ps_rabat || 0;       
          options.totalValue += (options.value.bruto_iznos*(options.value.ps_postorabata/100))
      }
      if (options.summaryProcess == 'finalize') {
          // Assigning the final value to "totalValue" here
          return options.totalValue;
      }
    }

    //// IZNOS KN
    if (options.name == "iznoskn") {  
        if (options.summaryProcess == 'start') {
            // Initializing "totalValue" here
            options.totalValue = 0;
        }
        if (options.summaryProcess == 'calculate') {
            // Modifying "totalValue" here
            // options.osnovica = options.value.pr_ulazvr || 0;
            // options.pdv = options.value.porez_iznos || 0;
            // options.totalValue += options.osnovica  + options.pdv  
            options.ukupno = this.iznosFooterIzmjene || this.iznosFooter || 0;
            options.totalValue = options.ukupno;
        }
        if (options.summaryProcess == 'finalize') {
            // Assigning the final value to "totalValue" here
            return options.totalValue;
        }
    } 
  }

  /** ---------------------- STAVKE DOKUMENTA ------------------------ */
  onToolbarPreparing(e: any) { 
    e.toolbarOptions.items.unshift({
      location: 'before',
      template: 'naslovTablice'   
      },
      {
        locateInMenu:'auto',
        location: 'before',
        template: "ispis",
      },  
    )
  }

  ispisUFE(uf_id) {
    this.printService.pdfUFA(uf_id);
  }

  editingRowKey: any;

  onEditorPreparing(e: any) {
    if (e.parentType === 'dataRow' && e.dataField === 'ps_ulazc' ||  e.dataField === 'neto_iznos' || e.dataField === 'pz_posto') {
      this.editingRowKey = e.row.key;
    }
  }

  onCijenaValueChanged = (e: any) => {
    const staraCijena = e.previousValue;
    let stariPorezIznos = 0;
    let stariNetoIznos = 0;
    let stariRabat = 0;
    if (this.editingRowKey !== undefined) {
      const redak = this.stavkeUFE.find((item) => item.ps_id === this.editingRowKey);
      if (redak) {
        redak.ps_ulazc = e.value;
        redak.neto_iznos = e.value * redak.ps_ulaz;

        stariNetoIznos = staraCijena * redak.ps_ulaz;
        stariPorezIznos = ((redak.pz_posto/100)+1)*stariNetoIznos - stariNetoIznos;
        stariRabat = ((redak.ps_postorabata/100))*stariNetoIznos;

        if(staraCijena != e.value) {
          this.loadingVisible = true;
          this.spremiNovuCijenu(e, redak);
        }

        redak.porez_iznos = ((redak.pz_posto/100)+1)*redak.neto_iznos - redak.neto_iznos;
        redak.ps_rabat = ((redak.ps_postorabata/100))*redak.neto_iznos;
        this.iznosFooter = this.iznosFooter - stariNetoIznos - stariPorezIznos;
        this.iznosFooterIzmjene = redak.neto_iznos + redak.porez_iznos + this.iznosFooter;
        this.iznosFooter = this.iznosFooterIzmjene;
      }
    }
  };

  onPorezValueChanged = (e: any) => {
    const stariPorez = e.previousValue;
    let stariPorezIznos = 0;
    let stariNetoIznos = 0;
    let stariRabat = 0;
    if (this.editingRowKey !== undefined) {
      const redak = this.stavkeUFE.find((item) => item.ps_id === this.editingRowKey);
      if (redak) {
        redak.pz_posto = e.value;

        stariNetoIznos = redak.ps_ulazc * redak.ps_ulaz;
        stariPorezIznos = ((redak.pz_posto/100)+1)*stariNetoIznos - stariNetoIznos;
        stariRabat = ((redak.ps_postorabata/100))*stariNetoIznos;
        if(stariPorez != e.value) {
          this.loadingVisible = true;
          this.spremiNoviPorez(e, redak);
        }

        redak.porez_iznos = ((redak.pz_posto/100)+1)*redak.neto_iznos - redak.neto_iznos;
        redak.ps_rabat = ((redak.ps_postorabata/100))*redak.neto_iznos;
        this.iznosFooter = this.iznosFooter - stariNetoIznos - stariPorezIznos;
        this.iznosFooterIzmjene = redak.neto_iznos + redak.porez_iznos //+ this.iznosFooter;
        this.iznosFooter = this.iznosFooterIzmjene;
      }
    }
  };


  onIznosValueChanged = (e: any) => {
    let stariNetoIznos = e.previousValue;
    let noviNetoIznos = e.value;
    let novaCijena = 0;
    let staraCijena = 0;
    if (this.editingRowKey !== undefined) {
      const redak = this.stavkeUFE.find((item) => item.ps_id === this.editingRowKey);
      if (redak) {
        staraCijena = redak.ps_ulazc;
        //novaCijena = noviNetoIznos / redak.ps_ulaz;
        novaCijena = parseFloat((e.value / redak.ps_ulaz).toFixed(10))
        this.onCijenaValueChanged({ previousValue: staraCijena, value: novaCijena });
      }

    }
  };

  spremiNovuCijenu(e, redak) {
    let podaciZaSlanje = {
      idfirma: this.idfirma,
      idkorisnik: this.idkorisnik,
      idufa: this.brojdok,
      pz_id: redak.prometzag_pz_id,
      ps_id: redak.ps_id,
      nova_cijena: redak.ps_ulazc,
      novi_porez: redak.pz_posto
    };
    
    this.api.uredi_ufu_primku_prije_zakljucivanja(podaciZaSlanje).subscribe(res => {
      this.loadingVisible = false;
      if(res.data[0][0].rezultat === 1) {
        this.dohvatiZavrsenePrimkePartnera(this.partner);
        this.dohvatiPodatkeUFEN(this.brojdok);
        this.dohvatiStavkeUFEN(this.brojdok)
        //this.calculateSummary = this.calculateSummary.bind(this);
        notify(res.data[0][0].poruka, 'success');
      }
      else {
        notify(res.data[0][0].poruka, 'error');
      }
    })
  }

  spremiNoviPorez(e, redak) {
    let podaciZaSlanje = {
      idfirma: this.idfirma,
      idkorisnik: this.idkorisnik,
      idufa: this.brojdok,
      pz_id: redak.prometzag_pz_id,
      ps_id: redak.ps_id,
      nova_cijena: redak.ps_ulazc,
      novi_porez: redak.pz_posto
    };
    
    this.api.uredi_ufu_primku_prije_zakljucivanja(podaciZaSlanje).subscribe(res => {
      this.loadingVisible = false;
      if(res.data[0][0].rezultat === 1) {
        this.dohvatiZavrsenePrimkePartnera(this.partner);
        this.dohvatiPodatkeUFEN(this.brojdok);
        this.dohvatiStavkeUFEN(this.brojdok)
        //this.calculateSummary = this.calculateSummary.bind(this);
        notify(res.data[0][0].poruka, 'success');
      }
      else {
        notify(res.data[0][0].poruka, 'error');
      }
    })
  }

  /** ----------------- ZAKLJUČI UFA ------------------------ */

  infoKonacnoSpremanje(){
    let encodedMessage = encodeHtml('Jeste li sigurni? Nakon toga ova faktura bit će zaključena i više se neće moći uređivati.');
    let myDialog = custom({
      title: 'Zaključivanje ulazne fakture',
      messageHtml: encodedMessage,
      buttons: [{
        text: 'DA',
        onClick: (e) => {
          return { buttonText: e.component.option("text") }
        }
      },
      {
        text: 'NE',
        onClick: (e) => {
          return { buttonText: e.component.option("text") }
        }
      }]
    });
    myDialog.show().then((dialogResult) => {
      if(dialogResult.buttonText === 'DA'){
        // this.kalkulacijaPopup = true;
        // this.loadingVisible = true;
        this.loadingVisible = true;
        let podaciZaSlanje = {
          idkorisnik: this.idkorisnik,
          idfirma: this.idfirma,
          access_token: this.access_token,
          idufa: this.brojdok,
          noveCijene: this.noveCijene
        }
        this.api.zavrsi_ufu(podaciZaSlanje).subscribe(res => {
          this.loadingVisible = false;
          if(res.success === true){
            notify(res.message, 'success');
            this.samoPregled = true;
            this.statusUFA = 'z';
            this.naslovStranice = 'Prikaz ulazne fakture';
            this.dohvatiPodatkeUFEZ(this.brojdok);
            this.postojeStavke = true;
            //this.dohvatiStavkeUFEZ(this.brojdok); 
            // setTimeout(() =>
            //   this.ispisUFE()
            //   , 600)
          } else {
            notify(res.message, 'error');
          }
        })
      }
    });
  }

  dohvatiPrimkeUFEZ(idufa){
    let podaci = {
      idkorisnik: this.idkorisnik,
      idfirma: this.idfirma,
      access_token: this.access_token, 
      idufa: idufa,
      idpartner: this.partner
    }   
    this.api.otvorenaprimkaPopis(podaci).subscribe(res =>{
      if(res.success === true){
        this.primke = res.data;
        this.odabranePrimke = res.data.filter(x => x.oznaka === 1).map(x => x.pz_id);
        this.primkePrikazDropDown = res.data.filter(x => x.oznaka === 1).map(x => x.pz_id); 
      }          
    })
  }

  onSelectionChanged(e){
    if(e.selectedRowKeys.length > 0){
        let usporedba = this.primkeZaSlanje.filter(item => e.selectedRowsData.some(items => item.pz_id === items.pz_id));
            usporedba.forEach(element => { element.oznaka = 1; });
    } if(e.currentDeselectedRowKeys.length > 0){       
        let usporedba = this.primkeZaSlanje.filter(item => e.currentDeselectedRowKeys.some(items => item.pz_id === items));
            usporedba.forEach(element => { element.oznaka = 0; });
    }    
  }

  spremiDropdown(e){
    let podaci = {
      idkorisnik: this.idkorisnik,
      idfirma: this.idfirma,
      access_token: this.access_token, 
      idufa: this.brojdok,
      uf_broj: this.brojUFE,
      arr_pz_id: this.primkeZaSlanje
    }
    this.primkePrikazDropDown = [];
    this.primkeZaSlanje.filter(x => x.oznaka === 1).forEach(element => {
      this.primkePrikazDropDown.push(element.pz_id)
    });     
    this.api.dodajOtvorenuPrimku(podaci).subscribe(res => {
      if(res.success === true){
        notify(res.message, 'success');
      } else {
        notify(res.message, 'error');
      } 
      this.dohvatiPodatkeUFEN(this.brojdok) //kako bi se osvježile vrijednosti
      this.dohvatiStavkeUFEN(this.brojdok);
      // this.dohvatiZavrsenePrimkePartnera(this.partner)
    })   
    this.dropdown.instance.close();
  }

  closeDropDown(e: any){
    this.dropdown.instance.close();
  }

  onToolbarTroskovi(e){
    e.toolbarOptions.items.unshift({
      location: 'before',
      template: 'naslovTablice'
      }
    )
  }

  onOpened(e:any){
      this.primkeTablica.instance.collapseAll(-1);
  }

  omoguciIzmjene() {
    this.omoguciZavrseneIzmjene = !this.omoguciZavrseneIzmjene;
  }
}